import { browserHistory } from 'react-router'

import { Paths } from 'utils/paths'
import { error } from 'utils/logger'

const Navigation = {
  // force browse to path
  go(path) {
    browserHistory.push(path)
  },

  // wrap initial page load API requests
  catchNotFound(given, props) {
    const actions = Array.isArray(given) ? given : [ given ]

    return Promise.all(actions).catch((err) => {
      error("CATCHING NAVIGATION ERROR", err)

      // either Swagger API error or fetch throwOnError
      const is404 = (err.action && err.action.payload.status === 404) ||
                    (err.response && err.response.status === 404) ||
                    (err.status && err.status === 404)

      if (is404) {
        if (props && props.notfound) {
          props.notfound()
        } else if (props && props.router) {
          props.router.push(Paths.notfound())
        } else {
          Navigation.go(Paths.notfound())
        }
      }

      return Promise.reject(err)
    })
  }

}

export default Navigation
